import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { getSitesByParentGroupAlerts } from "../Alerts/AlertsUtils/getSitesByParentGroupAlerts";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

const StepOneAddCalendar = ({
  newCalendarInfo,
  setNewCalendarInfo,
  parentAccounts,
  parentNames,
  navigate,
  setSiteOptions,
  setLoadingSites,
}: {
  newCalendarInfo: any;
  setNewCalendarInfo: any;
  parentAccounts: any;
  parentNames: any;
  navigate: NavigateFunction;
  setSiteOptions: any;
  setLoadingSites: Dispatcher<boolean>;
}) => {
  const [updatedCalendarInfo, setUpdatedCalendarInfo] =
    React.useState(newCalendarInfo);

  return (
    <div>
      <div className="absolute top-[160px] left-[30px]">
        <Autocomplete
          disablePortal
          options={
            parentAccounts[0]
              ? parentAccounts.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
              : []
          }
          getOptionLabel={(option) => option.name || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={parentNames.get(updatedCalendarInfo.group)}
          onChange={(event: any, newInputValue: any) => {
            if (!newInputValue?.id) {
              return;
            }
            getSitesByParentGroupAlerts(
              newInputValue.id,
              navigate,
              setSiteOptions,
              setLoadingSites
            );
            setUpdatedCalendarInfo((previousState: any) => {
              return {
                ...previousState,
                group: newInputValue.id,
              };
            });
            setNewCalendarInfo((previousState: any) => {
              return {
                ...previousState,
                group: newInputValue.id,
              };
            });
          }}
          sx={{ width: 350 }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Group"
              autoComplete="off"
              id="group_name"
              name="group_name"
            />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
        />
        <br></br>
        <br></br>
        <TextField
          id="sureview_subject"
          variant="standard"
          label="Calendar Name"
          value={updatedCalendarInfo.name}
          onChange={(event) => {
            setUpdatedCalendarInfo((previousState: any) => {
              return { ...previousState, name: event.target.value };
            });
            setNewCalendarInfo((previousState: any) => {
              return { ...previousState, name: event.target.value };
            });
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />
      </div>
    </div>
  );
};

export default StepOneAddCalendar;